export const detailUrl = ({ id }) => `/errand-settings/checklists/detail/${id}`;

export const overviewUrl = () => `/errand-settings/checklists`;
